
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeErtong extends Vue {
  @Prop()
  private message: any;
}
